module.exports = __webpack_public_path__ + "img/c68735b.jpg";